import JSX from "../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import { hideUserMessageActionsDetails } from "../user-actions.js";
import { addActionElementToBottomSender, deleteActionElementFromBottomSender } from "../../../messages/bottom.js";

export function AnswerActionElement(props: {
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>,
    withText: boolean
}){
    return !props.msg.deleted ? ( <div className="action-element"
             onClick={() => answerMessageClickEventHandler(props.message.value!)}
        >
            <div className="message-action-padding">
                <img src="/img/answer-to-message.svg" className="action-element-img"/>
            </div>
            {!!props.withText && <div className="message-action-padding" style={{color: 'var(--light-text)'}}>Ответить</div>}
        </div>
    ) : <></>

}




export function answerMessageClickEventHandler(message: HTMLDivElement) {

    removeAnswerBlockInBottom();
    hideUserMessageActionsDetails(message);
    const addElement: HTMLElement = <MessageAnswerBlock message={message}/>

    addActionElementToBottomSender(addElement);
}
export function removeAnswerBlockInBottom() {
    deleteActionElementFromBottomSender("message-answer-block");
}


export function MessageAnswerBlock({message}: { message: HTMLDivElement }) {

    const html: HTMLElement = (
        <div data-message-id={message.dataset.id} className="message-answer-block action-bottom-sender-block"
             onClick={() => closeAnswerBlockClickEventHandler()}
        >
            <div>Ответ на сообщение от&nbsp;</div>
            <div className="red-color">{message.dataset.nickname}</div>
        </div>
    );
    return html;
}


export function closeAnswerBlockClickEventHandler() {
    removeAnswerBlockInBottom();
}


export function hasAnswer(msg: IOneMessageJson) {
    return msg.answer_to_id !== null && msg.answer_to_id !== undefined;
}

